import { useEffect } from "react";
import {
  resolveEditableTarget,
  setFocusedEditableField,
} from "../../utilis/methods/voiceAssistant/fieldDictation";

type Props = {
  isVoiceEnabled: boolean;
};

export default function VoiceFieldDictationListener({ isVoiceEnabled }: Props) {
  useEffect(() => {
    if (!isVoiceEnabled) {
      setFocusedEditableField(null);
      return;
    }

    const syncFocusedField = () => {
      const editable = resolveEditableTarget(document.activeElement);
      setFocusedEditableField(editable);
    };

    const onFocusIn = (event: FocusEvent) => {
      const editable = resolveEditableTarget(event.target);
      setFocusedEditableField(editable);
    };

    const onFocusOut = () => {
      window.setTimeout(syncFocusedField, 0);
    };

    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("focusout", onFocusOut, true);
    syncFocusedField();

    return () => {
      document.removeEventListener("focusin", onFocusIn, true);
      document.removeEventListener("focusout", onFocusOut, true);
      setFocusedEditableField(null);
    };
  }, [isVoiceEnabled]);

  return (
    <style>{`
      [data-rcm-voice-field-active="true"] {
        outline: 2px solid rgba(25, 118, 210, 0.45) !important;
        outline-offset: 1px;
      }
    `}</style>
  );
}
